import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import type { SimilarSurvey } from '@ps/survey-utils';

import { SimilarSurveysApi } from '../../api/similar-surveys/similar-surveys.api';
import {
  SimilarSurveysPayloadMapper,
  type SimilarSurveysQuery,
} from '../../api/similar-surveys/mappers/similar-surveys.payload.mapper';
import { similarSurveysTargetingKey } from '../../utils/similar-surveys/similar-surveys-targeting-key';

@Injectable({ providedIn: 'root' })
export class SimilarSurveysService {
  private readonly _api = inject(SimilarSurveysApi);

  private readonly _payloadMapper = new SimilarSurveysPayloadMapper();

  public search(
    query: SimilarSurveysQuery,
    options: { searchGlobally: boolean },
  ): Observable<SimilarSurvey[]> {
    return this._api.search(this._payloadMapper.toPayload(query), options);
  }

  /**
   * Identifies a search by the request it would send, so a form change that
   * leaves the payload untouched (a retitle, a re-emitted hydration value, the
   * same options reselected in a different order) is not mistaken for one that
   * invalidates the results.
   */
  public targetingKey(query: SimilarSurveysQuery): string {
    return similarSurveysTargetingKey(this._payloadMapper.toPayload(query));
  }
}
